// removed by extract-text-webpack-plugin
module.exports = {"button-large":"NotificationPanel__button-large","buttonLarge":"NotificationPanel__button-large","panel-view":"NotificationPanel__panel-view","panelView":"NotificationPanel__panel-view","notification-icon":"NotificationPanel__notification-icon","notificationIcon":"NotificationPanel__notification-icon"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/NotificationPanel/NotificationPanel.mobile.css
// module id = 1400
// module chunks = 8